const formatGroupToLevelCount = ({
  isRaw = false,
  isPage = false,
  page = null,
  size = null,
  data = [], // 資料庫資料
  filter = null, // 資料篩選
  dateRangeColumns = null, // 日期範圍篩選
  groupOrders = {}, // 分類排序
  groupColumns = [], // 分類欄位
  headColumns = [], // 表格欄位
  levelColumns = [], // 欄位對應值
  categoryColumns = [], // 特定欄位的所有欄位值
  countKey = null, // 數量計算欄位
  createColumns = [], // 建立欄位
} = {}) => {
  if (filter || dateRangeColumns) {
    data = data.filter((item) => {
      let isValid = true;

      if (filter && item[filter.key] !== filter.value) return false;

      if (dateRangeColumns && dateRangeColumns.length > 0) {
        dateRangeColumns.forEach((dateColumn) => {
          if (dateColumn.start || dateColumn.end) {
            let start = dateColumn.start
                ? new Date(`${dateColumn.start} 00:00:00`)
                : null,
              end = dateColumn.end
                ? new Date(`${dateColumn.end} 24:00:00`)
                : null,
              value = item[dateColumn.key]
                ? new Date(item[dateColumn.key])
                : null;

            if (!value || (start && start > value) || (end && end < value))
              isValid = false;
          }
        });
      }

      return isValid;
    });
  }

  if (createColumns.length > 0) {
    data.forEach((item) =>
      createColumns.forEach((createAction) => createAction({ data: item }))
    );
  }

  let categoryData =
    categoryColumns.reduce((pre, cur) => ({ ...pre, [cur.key]: [] }), {}) || {};

  // 類型(group)分類
  let tempLevels = {};
  let groups = data.reduce((pre, cur) => {
    if (levelColumns.length > 0) {
      // 取得層級式欄位的各種欄位值組合
      const getDiffLevels = ({ tempLevels, index }) => {
        let value = cur[levelColumns[index].key] ?? "";
        if (levelColumns[index].isDate) value = new Date(value).getFullYear();
        if (!tempLevels[value]) tempLevels[value] = {};

        index++;
        if (index < levelColumns.length) {
          getDiffLevels({ tempLevels: tempLevels[value], index });
        }
      };
      getDiffLevels({ tempLevels, index: 0 });
    }

    let currentData = { ...cur };
    categoryColumns.forEach((category) => {
      let value = currentData[category.key];

      if (category.type === "date") {
        if (value) {
          value = new Date(value);
          value = value.getFullYear();
        }
      }

      if (!categoryData[category.key].includes(value))
        categoryData[category.key].push(value);
    });

    let combineKey = "",
      groupKeys = groupColumns.map((group) => {
        let nowKey = currentData[group.key];
        if (group.transferFun) {
          nowKey = group.transferFun(currentData);
          currentData[group.key] = nowKey;
        }
        combineKey += `${combineKey ? "_" : ""}${nowKey}`;
        return combineKey;
      });
    if (!combineKey) return pre;

    groupKeys.forEach((key) => {
      if (!pre[key]) pre[key] = [];
      pre[key].push(currentData);
    });

    return pre;
  }, {});

  // 整理層級式欄位的各種欄位值
  const formatLevels = ({ levels, index }) => {
    let returnVal = {
      ...levelColumns[index],
      options: Object.keys(levels).map((item, idx) => ({
        childKey: `type${idx}`,
        label: item,
      })),
    };

    index++;
    if (index < levelColumns.length) {
      returnVal.child = {};
      Object.values(levels).forEach((item, idx) => {
        returnVal.child[`type${idx}`] = formatLevels({ levels: item, index });
      });
    }

    return returnVal;
  };
  let finalLevels = formatLevels({ levels: tempLevels, index: 0 });

  // 整理設定檔 level 欄位
  const formatLevelColumns = ({ preLabel = [], preKey = [], data }) => {
    let final = data.options.map((option, index) => ({
      key: `${preLabel.length > 0 ? `${preLabel.join("_")}_` : ""}${
        option.label
      }`,
      rawKey: [...preKey, data.key],
      field: `${preLabel.length > 0 ? `${preLabel.join("_")}_` : ""}${
        option.label
      }${data.isNumber ? "_format" : ""}`,
      header: option.label,
      isControl: data.isControl,
      isSum: data.isSum,
      isHide: data.isHide,
      child: data.child
        ? formatLevelColumns({
            preLabel: [...preLabel, option.label],
            preKey: [...preKey, data.key],
            data: data.child[option.childKey],
          })
        : null,
    }));
    return final;
  };
  // 平整化 Level 陣列
  const flatArrLayers = ({ data }) => {
    const formatDetail = ({ data }) => {
      let tempLevel = [];
      data.forEach(({ child, ...item }) => {
        if (child) {
          tempLevel = [...tempLevel, ...formatDetail({ data: child })];
        }
        tempLevel = [...tempLevel, item];
      });
      return tempLevel;
    };

    return formatDetail({ data })
      .map((item) => (item.rawKey || []).join("_"))
      .filter((value, index, array) => {
        return array.indexOf(value) === index;
      })
      .map((item) => item.split("_"));
  };
  const columns = formatLevelColumns({ data: finalLevels });
  if (headColumns.length === 0)
    headColumns = flatArrLayers({
      data: columns,
    });

  categoryColumns.forEach((category) => {
    if (["date", "number"].includes(category.type)) {
      categoryData[category.key] = categoryData[category.key].sort(function (
        pre,
        next
      ) {
        return next - pre;
      });
    }
  });

  let formatData = Object.entries(groups)
    .map(([groupKey, detail]) => {
      let count = -1,
        result = {
          // 分割取得各類型原資料
          ...groupColumns.reduce((pre, cur) => {
            count++;
            let groupName = groupKey.split("_")[count] ?? null,
              order = groupOrders[cur.key]?.[groupName] ?? 99;
            if (cur.isNumber) groupName = Number(groupName);
            return { ...pre, [cur.key]: groupName, order };
          }, {}),
        };

      detail.forEach((item) => {
        headColumns
          .map((level) =>
            level
              .reduce(
                (pre, cur) => [
                  ...pre,
                  cur.headerName ? cur.headerName : item[cur] ?? "",
                ],
                []
              )
              .join("_")
          )
          .forEach((key) => {
            if (!result[key]) result[key] = 0;
            result[key] =
              result[key] +
              (countKey
                ? item[countKey]
                : typeof item[key] === "number"
                ? item[key]
                : 1);
          });
      });
      return result;
    })
    .sort(function (pre, next) {
      return pre.order - next.order;
    });

  let total = 0;
  if (page && size) {
    total = data.length;
    formatData = data.slice((page - 1) * size, (page - 1) * size + size);
  } else if (isRaw && isPage) {
    total = data.length;
    formatData = data;
  }

  return {
    category: categoryData,
    data: formatData,
    total,
    levelColumns: finalLevels,
    columns,
  };
};

// 整理設定檔 level 欄位
const formatLevelColumns = ({ preLabel = [], preKey = [], data }) => {
  try {
    let final = data.options.map((option, index) => ({
      key: `${preLabel.length > 0 ? `${preLabel.join("_")}_` : ""}${
        option.label
      }`,
      rawKey: [...preKey, data.key],
      field: `${preLabel.length > 0 ? `${preLabel.join("_")}_` : ""}${
        option.label
      }${data.isNumber ? "_format" : ""}`,
      header: option.label,
      isControl: data.isControl,
      isSum: data.isSum,
      child: data.child
        ? formatLevelColumns({
            preLabel: [...preLabel, option.label],
            preKey: [...preKey, data.key],
            data: data.child[option.childKey],
          })
        : null,
    }));
    return final;
  } catch (e) {}
};

// 平整化 columns 陣列
const flatColumnsLayers = ({ data }) => {
  const formatDetail = ({ data }) => {
    let tempLevel = [];
    data.forEach(({ child, ...item }) => {
      if (child) {
        tempLevel = [...tempLevel, ...formatDetail({ data: child })];
      }
      tempLevel = [...tempLevel, item];
    });
    return tempLevel;
  };

  return formatDetail({ data })
    .map((item) => (item.rawKey || []).join("_"))
    .filter((value, index, array) => {
      return array.indexOf(value) === index;
    })
    .map((item) => item.split("_"));
};

export { formatGroupToLevelCount, formatLevelColumns, flatColumnsLayers };
